import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'

export function useIsLaunching() {
  return useSelector<RootState, boolean>(isLaunchingSelector)
}

export function isLaunchingSelector({ socketServer, launchHosting }: RootState): boolean {
  return !!socketServer.roomState?.isLaunching || !!launchHosting.launchHostingLoading
}
